import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

/**
 * Read-only taxonomy product counts snapshot (non-archived, via membershipIds).
 */
const getCatalogTaxonomyProductCounts = async () => {
  try {
    const callable = functions.httpsCallable('getCatalogTaxonomyProductCounts')
    const result = await callable({})
    return {
      ok: true,
      data: result.data,
    }
  } catch (error) {
    console.error('[getCatalogTaxonomyProductCounts] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default getCatalogTaxonomyProductCounts
